import Share from './ui/main/Share';

export default Share;
